import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";
import { useMainStore } from "../store";
import Feature from "../../models/Feature";

export const useCompaniesStore = defineStore('companiesModule', {
    state: () => ({
        mainStore: useMainStore(),
        featureRepo: useRepo(Feature),
    }),
    actions: {
        hasFeature(featureKey) {
            const feature = this.featureRepo.where('key', featureKey).first();
            if (!feature) return false;
            return this.mainStore.currentCompany.feature_ids.includes(feature.id);
        },
        creationDate() {
            return this.mainStore.currentCompany.created_at;
        },
        setSeekStatus(seekStatus) {
            this.seek_status = seekStatus;
        }
    },
});
